// extracted by mini-css-extract-plugin
module.exports = {"placeholder":"Placeholder_placeholder__ysuDS","actionButton":"Placeholder_actionButton__1LHN9"};